import {
  IGeneralPetCareItem,
  IGetGeneralPetCareResponse,
} from "../../../services/Standard-of-care/standard-of-care.interface";
import { IPetCareState, petCareActions } from "../../../state/petCareData";
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";

export const usePetCareStore = () => {
  const dispatch = useDispatch();
  const { petCareData, petCareUpdate, selectedPrescription, selectedPet } = useSelector(
    (state: IRootState) => state.carePage as IPetCareState,
  );

  const setPetCareData = (data: IGetGeneralPetCareResponse | undefined) => {
    dispatch(petCareActions.setPetCareData(data));
  };

  const updateFulfilledMonthStatus = (petId: string, updatePetData: IGeneralPetCareItem) => {
    dispatch(petCareActions.updateFulfilledMonthStatus(petId, updatePetData));
  };

  const setSelectedPrescription = (prescription: any) => {
    dispatch(petCareActions.setSelectedPrescription(prescription));
  };

  const clearSelectedPrescription = () => {
    dispatch(petCareActions.setSelectedPrescription(null));
  };

  const setSelectedPet = (pet?: IGeneralPetCareItem) => {
    dispatch(petCareActions.setSelectedPet(pet));
  };

  const clearSelectedPet = () => {
    dispatch(petCareActions.setSelectedPet(undefined));
  };

  return {
    petCareData,
    petCareUpdate,
    selectedPrescription,
    selectedPet,
    setPetCareData,
    updateFulfilledMonthStatus,
    setSelectedPrescription,
    clearSelectedPrescription,
    setSelectedPet,
    clearSelectedPet,
  };
};
